import { atom } from 'jotai';
import {
  comparisonSelectedCompetitionsAtom,
  comparisonSelectedSeasonsAtom,
  unwrappedComparisonPlayerTeamAtom,
} from '@/atoms/filters/player/playerComparisonFilters';
import {
  comparisonTeamSelectedCompetitionsAtom,
  comparisonTeamSelectedSeasonsAtom,
} from '@/atoms/filters/team/teamComparisonFilters';
import { unwrappedPlayerTeamsOptionsAtom } from '@/atoms/queries/players';

export const comparisonPlayerInfoAtom = atom(get => ({
  team: get(unwrappedComparisonPlayerTeamAtom),
  selectedCompetitions: get(comparisonSelectedCompetitionsAtom),
  selectedSeasons: get(comparisonSelectedSeasonsAtom),
  teamOptions: get(unwrappedPlayerTeamsOptionsAtom),
}));

export const comparisonTeamInfoAtom = atom(get => ({
  selectedCompetitions: get(comparisonTeamSelectedCompetitionsAtom),
  selectedSeasons: get(comparisonTeamSelectedSeasonsAtom),
}));
